import React from 'react';
import { Box, Text, VStack, HStack, IconButton, useColorModeValue } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const GameOverlay = ({ isOpen, onClose, children }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <AnimatePresence>
      {isOpen && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="rgba(0, 0, 0, 0.5)"
          zIndex={1000}
          display="flex"
          alignItems="center"
          justifyContent="center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Box
            bg={bgColor}
            p={6}
            borderRadius="lg"
            boxShadow="xl"
            maxW="90%"
            maxH="90%"
            overflow="auto"
            borderWidth="1px"
            borderColor={borderColor}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <HStack justify="space-between" mb={4}>
              <Text fontSize="xl" fontWeight="bold">
                Game Overlay
              </Text>
              <IconButton
                icon={<FaTimes />}
                variant="ghost"
                onClick={onClose}
                aria-label="Close overlay"
              />
            </HStack>
            <VStack spacing={4}>
              {children}
            </VStack>
          </Box>
        </Box>
      )}
    </AnimatePresence>
  );
};

export default GameOverlay;